import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "../../helpers/apiHelper/requestHelper";
import { toastify } from "../../helpers/toast/toastify";
import { missingPopup } from "../../helpers/dataHelper/missingData";
import { useSelector } from "react-redux";
import FloatingTextFiled from "../../pages/sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import BubbleSvgButton from "../../pages/sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

export default function ForgotPassword() {
  const api = useApi();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const user = useSelector((state) => state?.user?.user);

  useEffect(() => {
    if (user) {
      if (user?.role === "leader") navigate("/leader/dashboard");
      else if (user?.role === "member")
        navigate("/member/dashboard", { replace: true });
      else if (user?.role === "admin") navigate("/admin/dashboard");
    }
  }, [window.location, user]);

  const resetPassword = async () => {
    if (!email) {
      missingPopup("Email");
    } else {
      const response = await api("post", "auth/forgotemail", { email });
      if (response?.status) {
        navigate("/login");
        toastify("Reset link has been sent to your email.", "success");
      } else {
        // console.log("this is a forget password function running", response?.message);
        toastify(response?.message);
      }
    }
  };

  return (
    <div className="onboardinLayout">
      <div className="onboardingCard">
        <div className="onboardingCardTopBox">
          <p
            className="loginTop"
            onClick={() => {
              if(localStorage.getItem("fromRoute")==="community"){
                navigate(-1)
                return;
              }
              navigate("/login");
            }}
          >
            Back to Log In
          </p>
        </div>
        <div className="onboardingCardContentBox">
          <div className="headingBox withHeight">
            <h2 className="title">Reset password</h2>
            <p className="subText">
              Enter your email address and we'll send you a link to reset your password
            </p>
          </div>
          <div className="inputBox">
            <FloatingTextFiled
              className="onboardingInput loginSignUpInput"
              forLabel="Email"
              label="Your email"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              type="email"
              value={email}
            />
          </div>
          <BubbleSvgButton
            onClick={resetPassword}
            text="Reset Password"
            type="button"
            variant="green"
            containerStyling={{
              justifyContent: "center",
            }}
          />
        </div>
      </div>
    </div>
  );
}